import { render } from "./ConfigurationPanelTabContentFieldGroup.vue?vue&type=template&id=9b725326&scoped=true"
import script from "./ConfigurationPanelTabContentFieldGroup.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPanelTabContentFieldGroup.vue?vue&type=script&lang=ts"

import "./ConfigurationPanelTabContentFieldGroup.vue?vue&type=style&index=0&id=9b725326&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b725326"

export default script